import Entity from './Entity';

import ImageUrlHelper, {Options} from '../helpers/ImageUrlHelper';

export default class Illustration implements Entity {
  constructor(
    public id: number,
    public name: string,
    public originalImageUrl: string,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }
}
